<div>
    <button mat-button [matMenuTriggerFor]="menu" class="iconoUsuario" style="height: 115px">
        <span class="material-icons">
            manage_accounts
        </span>
        {{name.charAt(0)+firstName.charAt(0) | uppercase}}</button>
    <mat-menu #menu="matMenu" class="userMenu">
        <div class="mat-menu-content">
            <button (click)="openModalToChangePassword()" mat-menu-item>{{'USER.CHANGE_PASSWORD' | translate}}</button>
            <button (click)="logout()" mat-menu-item>{{'USER.LOGOUT' | translate}}</button>
        </div>
    </mat-menu>

</div>